import { Box } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { AuthoringReviewSection } from "authoring/components/authoring-review-section"
import { AuthoringRichTextReadOnly } from "authoring/components/authoring-rich-text-readonly"

const NO_AMENDS_LABEL = "No change in this version"

// A lighter read-only wrapper than ScheduleCommentaryAuthorNoteSection - collapse state lives in
// the dialog's own local state instead of localStorage, since this snapshot has no draftId to key by.
export function ScheduleCommentaryPreviewSection({ item: note, collapsedKeys, onToggleSection }) {
    const isCollapsed = collapsedKeys.has(note.amendsKey)
    const opacity = note.hasAmends ? 1 : 0.6

    return (
        <Bound
            hasAmends={note.hasAmends}
            isCollapsed={isCollapsed}
            onToggleCollapsed={() => onToggleSection(note.amendsKey)}
        >
            <Box sx={{ opacity }} data-cy="schedule-commentary-preview-section">
                <AuthoringReviewSection
                    title={note.label}
                    readOnly={<AuthoringRichTextReadOnly content={note.content} emptyLabel={NO_AMENDS_LABEL} />}
                    dataCy="authoring-review-section"
                />
            </Box>
        </Bound>
    )
}
